import sectionTableSmallB1Css from '../css-snippets/section-table-small-b1';

const html = `
<style>${sectionTableSmallB1Css}</style>
<div class="wrapper-container" id="" data-id="" data-attribute="wrapper-container" data-background-color="#ffffff"
  data-enable-background-image="false" data-background="#ffffff" data-top-padding="true" data-bottom-padding="true"
  data-text-color="#000000" style="--text-color: #000000;
  color: #000000;
  background-color: rgb(255, 255, 255);">

  <div class="container">
    <div class="wrap-content">
      <div data-attribute="title-content" class="title-content">
        <h3 style="text-align:center;">Not All Outdoor Lights Are Created Equal</h3>
        <p style="text-align:center;">Lorem ipsum dolor sit amet consectetur adipisicing elit. Deleniti voluptatum ipsum
          pariatur.</p>
      </div>

      <div class="table-area">
        <div class="table-add" data-attribute="table-add" data-col-border="false" data-row-border="true"
          data-border-color="#00000033" data-border-spacing-vertical="0" data-border-spacing-horizontal="0"
          data-border-weight="1px"
          style="--border-color: #00000033; --border-spacing-vertical: 0px; --border-spacing-horizontal: 0px; --border-weight: 1px;">
          <table>
            <thead>
              <tr>
                <th style="height:80px;padding:10px;text-align:center;width:200px;">&nbsp;</th>
                <th style="background-color:#355052;height:80px;padding:10px;text-align:center;width:200px;"><span
                    style="color:hsl(0, 0%, 100%);"><strong>Kaliqo Lanterns</strong></span></th>
                <th style="height:80px;padding:10px;text-align:center;width:200px;"><span
                    style="color:rgb(222,227,229);">Generic Solar Lights</span></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="height:80px;padding:10px;text-align:center;width:200px;"><span
                    style="color:hsl(0, 0%, 0%);"><strong>Realistic flame effect</strong></span></td>
                <td style="background-color:#355052;height:80px;padding:10px;text-align:center;width:200px;"><span
                    style="color:hsl(0, 0%, 100%);"><strong>✅ Yes</strong></span></td>
                <td style="height:80px;padding:10px;text-align:center;width:200px;"><span
                    style="color:hsl(0, 75%, 60%);"><strong>No</strong></span></td>
              </tr>
              <tr>
                <td style="height:80px;padding:10px;text-align:center;width:200px;"><span
                    style="color:hsl(0, 0%, 0%);"><strong>Dusk-to-dawn performance</strong></span></td>
                <td style="background-color:#355052;height:80px;padding:10px;text-align:center;width:200px;"><span
                    style="color:hsl(0, 0%, 100%);"><strong>✅ Yes</strong></span></td>
                <td style="height:80px;padding:10px;text-align:center;width:200px;"><span
                    style="color:hsl(0, 75%, 60%);"><strong>Inconsistent</strong></span></td>
              </tr>
              <tr>
                <td style="height:80px;padding:10px;text-align:center;"><span
                    style="color:hsl(0, 0%, 0%);"><strong>Fully weatherproof</strong></span></td>
                <td style="background-color:#355052;height:80px;padding:10px;text-align:center;"><span
                    style="color:hsl(0, 0%, 100%);"><strong>✅ Yes</strong></span></td>
                <td style="height:80px;padding:10px;text-align:center;"><span
                    style="color:hsl(0, 75%, 60%);"><strong>Often breaks</strong></span></td>
              </tr>
              <tr>
                <td style="text-align:center;"><span style="color:hsl(0, 0%, 0%);"><strong>No wiring or tools
                      required</strong></span></td>
                <td style="background-color:#355052;height:80px;padding:10px;text-align:center;"><span
                    style="color:hsl(0, 0%, 100%);"><strong>✅ Yes</strong></span></td>
                <td style="text-align:center;"><span style="color:hsl(0, 75%, 60%);"><strong>Sometimes
                      needed</strong></span></td>
              </tr>
              <tr>
                <td style="text-align:center;"><span style="color:hsl(0, 0%, 0%);"><strong>Long-term
                      durability</strong></span></td>
                <td style="background-color:#355052;height:80px;padding:10px;text-align:center;"><span
                    style="color:hsl(0, 0%, 100%);"><strong>✅ Premium build</strong></span></td>
                <td style="text-align:center;"><span style="color:hsl(0, 75%, 60%);"><strong>Cheap
                      plastics</strong></span></td>
              </tr>
              <tr>
                <td style="text-align:center;"><span style="color:hsl(0, 0%, 0%);"><strong>Satisfaction
                      guarantee</strong></span></td>
                <td style="background-color:#355052;height:80px;padding:10px;text-align:center;"><span
                    style="color:hsl(0, 0%, 100%);"><strong>100 days</strong></span></td>
                <td style="text-align:center;"><span style="color:hsl(0, 75%, 60%);"><strong>None</strong></span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>
</div>
`;
export default html;
